import { Box } from '@chakra-ui/react';
import { FormikHelpers } from 'formik';
import { useSignUp, useUpdateUser } from 'hooks';
import { checkIfError } from 'utils/helpers';
import { IOption } from 'types';
import { AccountStatus } from 'constants/accountStatuses';

import UserForm, { UserFormValues } from './UserForm';
import { IUserResource, IUserResourceWithRelations } from '../../../../server/types';

type UserProps = {
  data?: Partial<IUserResource>;
  roles: IOption[];
  onSubmit: (response: IUserResourceWithRelations) => void;
};

const User = ({ data, roles, onSubmit }: UserProps) => {
  const [signUp, { error: registerError }] = useSignUp();
  const [updateUser, { error: updateError }] = useUpdateUser();

  const handleSubmit = async (values: UserFormValues, { setSubmitting }: FormikHelpers<UserFormValues>) => {
    const phoneValues = {
      phone: values.phone.replace(/\D/g, ''),
    };

    const {
      deleted,
      __v: version,
      _id: id,
      recaptcha,
      name,
      confirmPassword,
      isAdmin,
      ...fieldValues
    } = values as UserFormValues & Record<string, string | boolean>;

    const params = {
      ...fieldValues,
      ...phoneValues,
    };

    const fn = !data?.id ? signUp({ ...params, isAdmin: true }) : updateUser(data.id, params);

    const response = await fn;

    if (checkIfError(response)) {
      setSubmitting(false);
      return;
    }

    onSubmit(response);

    setSubmitting(false);
  };

  return (
    <Box>
      <UserForm
        error={registerError ?? updateError}
        onSubmit={handleSubmit}
        changePassword={!!data?.id}
        buttonText={data?.id ? 'UPDATE' : 'CREATE'}
        data={data}
        roles={roles}
        admin
        initialValues={{
          firstName: '',
          lastName: '',
          email: '',
          password: '',
          confirmPassword: '',
          country: '',
          state: '',
          zipCode: '',
          company: '',
          phone: '',
          status: AccountStatus.APPROVED,
        }}
      />
    </Box>
  );
};

export default User;
